<!-- no divs here to integrate nicely into his-tree-select -->
<button #inputElement class="transparent selectButton" hisImage="ARROW_RIGHT_FAT" alt="" (click)="show(); $event.preventDefault()">
  <span>{{'genericSearch.selectFromTree' | hisUi}}</span>
</button>
@if (showDeleteButton && !singleSelect && selectedData.length > 0) {
  <button
    class="transparent selectButton" hisImage="PANEL_CLOSE" alt=""
    (click)="deleteAll(); $event.preventDefault()">
    <span>{{'genericSearch.deleteSelectedItems' | hisUi}}</span>
  </button>
}

<p-dialog appendTo="body"
  [(visible)]="visible"
  [draggable]="false"
  [closeOnEscape]="true"
  [resizable]="true"
  [responsive]="true"
  [modal]="true"
  [blockScroll]="true"
  [header]="title">
  <div class="containerTreeTablePopup">
    <!--
    treeTable: comparison of tree elements with selection elements
    can be done by dataKey, compareSelectionBy="equals" or
    compareSelectionBy="deepEquals" (default).
    Using a dataKey is said to be the fastest choice.
    -->
    <p-treeTable [value]="tree"
      [selectionMode]="singleSelect ? 'single' : 'multiple'"
      [selection]="selectedData"
      dataKey="id"
      [rowHover]="true"
      onclick="event.stopPropagation(); return true;"> <!-- fixes #240237 -->

      <ng-template #header>
        <tr>
          <!-- singleSelect -->
          @if (singleSelect) {
            <th class="treeCellHeaderSingleSelect"><span class="treeCellHeaderContent">{{'genericSearch.rowselect' | hisUi}}</span></th>
          }
          <!-- single element select column of multiSelect -->
          @if (!singleSelect) {
            <th class="treeCellHeadercolumnMultiSelect"><span class="treeCellHeaderContent">{{'genericSearch.rowselect' | hisUi}}</span></th>
          }
          <!-- subtree select column of multiSelect -->
          @if (!singleSelect && showSubtreeSelectColumn) {
            <th class="treeCellHeaderSubtreeSingleSelect"><span class="treeCellHeaderContent">{{'genericSearch.subTreeSelect' | hisUi}}</span></th>
          }
          <!-- tree data -->
          <th>{{'common.components.selectManyPicklist.chooseFrom' | hisUi}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
        <!--
        Either highlighting of selected nodes is not working correctly in
        p-treeTable or I failed to find out how to use it properly.
        As a workaround, we set the highlighting style manually.
        -->
        <tr  [ngClass]="rowNode.level === 0 ? 'level_0' :null" [class]="(rowData.selected || rowData.subTreeSelected) ? 'ui-state-highlight' : ''">

          <!-- singleSelect -->
          @if (singleSelect) {
            <td class="treeCellSingleSelect">
              <button
                (click)="doSingleSelect(rowNode.node)" hisImage="arrow_left"
                class="icon" [title]="'genericSearch.tree.selectNode' | hisUi: rowData.defaulttext">
              </button>
            </td>
          }
          <!-- single element select column of multiselect -->
          @if (!singleSelect) {
            <td class="treeCellcolumnMultiSelect">
              <input type="checkbox"
                [(ngModel)]="rowData.selected"
                [disabled]="isNodeSelectable(rowData)"
                [id]="rowData.checkbox1Id"
                [title]="'genericSearch.tree.selectNode' | hisUi: rowData.defaulttext">
              <label [for]="rowData.checkbox1Id" title="{{ (rowData.selected ? 'genericSearch.tree.removeNode' : 'genericSearch.tree.selectNode') | hisUi:rowData.defaulttext}}" style="font-size: 0">{{'genericSearch.tree.selectNode' | hisUi: rowData.defaulttext}}</label>
            </td>
          }
          <!-- subtree select column of multiselect -->
          @if (!singleSelect && showSubtreeSelectColumn) {
            <td class="treeCellSubtreeSingleSelect">
              @if (rowNode.node.children.length > 0) {
                <input type="checkbox"
                  [(ngModel)]="rowData.subTreeSelected"
                  [id]="rowData.checkbox2Id"
                  [title]="'genericSearch.tree.selectNodeAndSubNodes' | hisUi: rowData.defaulttext"
                  [disabled]="isSubtreeNodeSelectable(rowData)">
              }
              <label [for]="rowData.checkbox2Id" [title]="'genericSearch.tree.selectNodeAndSubNodes' | hisUi: rowData.defaulttext" style="font-size: 0">{{'genericSearch.tree.selectNodeAndSubNodes' | hisUi: rowData.defaulttext}}</label>
            </td>
          }
          <!-- tree data -->
          <td>
            <div class="treeTableTogglerContainer treeTableTogglerContainer--inDialog"><!-- fix for #312308 -->
              <p-treeTableToggler
                [rowNode]="rowNode"
                [buttonTitle]="rowNode.node.expanded ? 'Level ' + (rowNode.level + 1) + ' ' + ('de.his.sys.collapse' | hisUi: rowData.defaulttext) : 'Level ' + (rowNode.level + 1) + ' ' + ('de.his.sys.expand' | hisUi: rowData.defaulttext)">
              </p-treeTableToggler>
            </div>
            <div class="treeCellContent">{{rowData.defaulttext}}</div>
          </td>
        </tr>
      </ng-template>
    </p-treeTable>
  </div>
  <div class="clearerSpaceAboveHalfEm"></div>
  <ng-template #footer>
    @if (!singleSelect) {
      <button hisImage="TICK" class="button_highlighted marginRightStandard" (click)="save($event)">{{'genericSearch.returnSelected' | hisUi}}</button>
    }
    <button hisImage="RED_X" class="button_highlighted blue" (click)="cancel($event)">{{'genericSearch.backToParentSearch' | hisUi}}</button>
  </ng-template>
</p-dialog>
